export const ADDRESS = 'address';
export const PACKAGE = 'package';
export const OWNER = 'owner';
export const PAYMENT = 'payment';
